import React, { Component } from "react";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import { connect } from "react-redux";
import { generateOtp } from "../../store/actions";
import Image from "../Image";
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: { value: "" },
      arnCode: { value: "" },
      password: { value: "" },
      confirmPassword: { value: "" },
      showPassword: false,
      confirmShowPassword: false,
    };
  }

  changeValue = (label) => (event) => {
    this.setState({
      [label]: { value: event.target.value },
    });
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;
    this.setState({
      [label]: {
        value,
        isError: !value,
        errorMessage: `${label === "userId" ? "User ID" : label} is mandatory`,
      },
    });
  };

  keyPress = (label) => (e) => {
    if (e.key === "Enter") {
      // Do code here
      if (label === "userId") {
        this.arnCodeField.focus();
      } else if (label === "arnCode") {
        this.passwordField.focus();
      } else if (label === "password") {
        this.confirmPasswordField.focus();
      } else {
        this.generateOtp();
      }
      e.preventDefault();
    }
  };

  generateOtp = async () => {
    const { showPassword, confirmShowPassword, ...others } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => {
      return !!this.state[key].value;
    });
    const isPasswordEqual =
      this.state.password.value === this.state.confirmPassword.value;
    if (!findError) {
      keys.forEach((key) => {
        !this.state[key].value &&
          this.setState({
            [key]: {
              ...this.state[key],
              isError: true,
              errorMessage: `${
                key === "userId"
                  ? "User ID"
                  : key === "password"
                  ? "Password"
                  : key === "arnCode"
                  ? "ARN Code"
                  : key === "confirmPassword"
                  ? "Confirm Password"
                  : key
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !this.state[key].value);
      switch (firstErroredKey) {
        case "userId":
          this.userIdField.focus();
          break;
        case "password":
          this.passwordField.focus();
          break;
        case "arnCode":
          this.arnCodeField.focus();
          break;
        case "confirmPassword":
          this.confirmPasswordField.focus();
          break;
      }
      return;
    }
    if (!isPasswordEqual) {
      this.setState({
        confirmPassword: {
          ...this.state.confirmPassword,
          isError: true,
        },
      });
      this.confirmPasswordField.focus();
      return;
    }

    const payload = {
      UserId: this.state.userId.value,
      ARNCode: `ARN-${this.state.arnCode.value}`,
      password: this.state.password.value,
    };
    const response = await this.props.generateOtp(payload);
    if (response) {
      this.props.history.push({
        pathname: "/otp",
        state: {
          payload: {
            ...payload,
            ...response,
          },
        },
      });
    }
  };

  render() {
    const { userId, password, arnCode, confirmPassword } = this.state;

    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 48,
          }}
        >
          <Image src={"/images/kfinkart-logo.svg"} alt="field_image" />
        </div>
        {/* <div className="otp-text1">Sign Up</div> */}
        <div className="form_tabs_list">
          <span
            className="sign_up_btn sign_btn mouse-pointer"
            onClick={() => this.props.history.push("./login")}
          >
            Sign In
          </span>
          <span
            className="sign_in_btn sign_btn mouse-pointer"
            onClick={() => this.props.history.push("./register")}
          >
            Sign Up
          </span>
        </div>
        <div className="input-margin">
          <Input
            name="User ID"
            isDark={true}
            bordercolor="#384455"
            className="Input-field-div-dark"
            placeholder={"User ID"}
            image={"/images/kfin_userid.svg"}
            // autoFocus={true}
            value={userId.value}
            onChange={this.changeValue("userId")}
            onBlur={this.showError("userId")}
            isShowError={userId.isError}
            errorMessage={userId.errorMessage}
            inputref={(ele) => (this.userIdField = ele)}
            onKeyPress={this.keyPress("userId")}
          />
        </div>
        <div className="input-margin">
          <Input
            name="ARN Code"
            isDark={true}
            bordercolor="#384455"
            className="Input-field-div-dark"
            placeholder={"ARN Code"}
            image={"/images/kfin_userid.svg"}
            errorMessage={arnCode.errorMessage}
            value={arnCode.value}
            onChange={this.changeValue("arnCode")}
            onBlur={this.showError("arnCode")}
            isShowError={arnCode.isError}
            inputref={(ele) => (this.arnCodeField = ele)}
            onKeyPress={this.keyPress("arnCode")}
          />
        </div>

        <Input
          name="Password"
          errorMessage={password.errorMessage}
          type={!!this.state.showPassword ? "text" : "password"}
          isDark={true}
          bordercolor="#384455"
          className="Input-field-div-dark"
          placeholder={"Password"}
          image2={
            !!this.state.showPassword
              ? "/images/kfin_eye_open.svg"
              : "/images/kfin_eye_close.svg"
          }
          image={"/images/kfin_password.svg"}
          height={18}
          onClick={() =>
            this.setState({
              showPassword: !this.state.showPassword,
            })
          }
          value={password.value}
          onChange={this.changeValue("password")}
          onBlur={this.showError("password")}
          isShowError={password.isError}
          inputref={(ele) => (this.passwordField = ele)}
          onKeyPress={this.keyPress("password")}
        />
        <div
          className="password-regualations input-margin"
          style={{ color: "white" }}
        >
          <span className="pass-star" style={{ color: "white" }}>
            *
          </span>{" "}
          Password should be at least 8 characters in length & should contain at
          least 1 uppercase alphabet (A-Z), 1 special character and 1 numeric
          character
        </div>
        <Input
          name="Confirm Password"
          name="Password"
          errorMessage={password.errorMessage}
          type={!!this.state.showPassword ? "text" : "password"}
          isDark={true}
          bordercolor="#384455"
          className="Input-field-div-dark"
          placeholder={"Password"}
          image2={
            !!this.state.showPassword
              ? "/images/kfin_eye_open.svg"
              : "/images/kfin_eye_close.svg"
          }
          image={"/images/kfin_password.svg"}
          height={18}
          errorMessage={confirmPassword.errorMessage}
          type={!!this.state.confirmShowPassword ? "text" : "password"}
          onClick={() =>
            this.setState({
              confirmShowPassword: !this.state.confirmShowPassword,
            })
          }
          value={confirmPassword.value}
          onChange={this.changeValue("confirmPassword")}
          onBlur={this.showError("confirmPassword")}
          isShowError={confirmPassword.isError}
          inputref={(ele) => (this.confirmPasswordField = ele)}
          onKeyPress={this.keyPress("confirmPassword")}
        />
        <Signbutton
          buttontitle="Generate OTP"
          isDark={true}
          onClick={this.generateOtp}
        />
        <div className="login-no-account">
          Already have an account ?{" "}
          <span
            className="login-no-account-span mouse-pointer"
            onClick={() => this.props.history.push("./login")}
          >
            SIGN IN
          </span>
        </div>
        <div style={{ textAlign: "center", marginTop: 30 }}>
          <a
            href="https://mfs.kfintech.com/mfs/Generalpages/KFinKart_termsconditions.aspx"
            target="_blank"
            style={{
              textAlign: "center",
              fontFamily: "OpenSans-Regular",
              fontSize: 15,
              color: "white",
              textDecoration: "underline",
              width: "100%",
            }}
          >
            Terms and Conditions*
          </a>
        </div>
      </div>
    );
  }
}

export default connect(null, { generateOtp })(Register);
